export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/opinion/query`,
          data
        });
      },
      /**
       * 删除
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/opinion/delete?id=${data[0].id}`,
              data
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/opinion.js